import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import Types from '../components/Types';
import CodeInfo from '../components/CodeInfo';
import ParamsTable from '../components/ParamsTable';
import ExampleItems from '../components/ExampleItems';
var PropertyItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PropertyItem, _React$Component);
  function PropertyItem() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = PropertyItem.prototype;
  _proto.render = function render() {
    var data = this.props.data;
    var pid = data.pid,
      override = data.override,
      deprecated = data.deprecated,
      name = data.name,
      types = data.types,
      description = data.description,
      codeInfo = data.codeInfo,
      examples = data.examples,
      params = data.params;
    var properties = params.slice();
    properties.pop();
    return /*#__PURE__*/React.createElement("div", {
      id: pid,
      className: "definition-list"
    }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", {
      className: "subsection-term"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "title"
    }, deprecated ? /*#__PURE__*/React.createElement("span", {
      className: "signiture deprecated"
    }, "deprecated") : null, override ? /*#__PURE__*/React.createElement("span", {
      className: "signiture override"
    }, "override") : null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, name, ": "), " ", /*#__PURE__*/React.createElement(Types, {
      data: types
    }), /*#__PURE__*/React.createElement(CodeInfo, {
      data: codeInfo
    }))), /*#__PURE__*/React.createElement("dd", {
      className: "subsection-description"
    }, /*#__PURE__*/React.createElement("p", {
      className: "description"
    }, description), /*#__PURE__*/React.createElement(ParamsTable, {
      properties: properties,
      isPropertyTitle: true
    }), /*#__PURE__*/React.createElement(ExampleItems, {
      items: examples
    }))));
  };
  return PropertyItem;
}(React.Component);
export default PropertyItem;